const ContactUsFieldNames = {
  SUBJECT_ID: 'subjectId',
  MESSAGE: 'message',
};

export default ContactUsFieldNames;
